import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuthContext } from '../hooks/useAuthContext';
import './FeaturedProducts.css';

export default function FeaturedProducts() {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        setIsAdmin(idTokenResult.claims?.admin || false);
      }
    };
    checkAdminStatus();
  }, [user]);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      const q = query(collection(db, 'products'), where('featured', '==', true));
      const querySnapshot = await getDocs(q);
      const productsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setFeaturedProducts(productsList);
    };

    fetchFeaturedProducts();
  }, []);

  const removeFeatured = async (e, productId) => {
    e.stopPropagation(); // Prevent card click when removing
    const productRef = doc(db, 'products', productId);
    await updateDoc(productRef, { featured: false });
    setFeaturedProducts(featuredProducts.filter(product => product.id !== productId));
  };

  const handleCardClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <div className="featured-section">
      <h2 className="featured-title">Featured Products</h2>
      <div className="featured-grid">
        {featuredProducts.map((product) => (
          <div 
            key={product.id} 
            className="product-card"
            onClick={() => handleCardClick(product.id)}
          >
            <div className="product-image-container">
              <img src={product.images[0]} alt={product.name} className="product-image" />
            </div>
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              <p className="product-price">&#8358;{product.price.toFixed(2)}</p>
              {isAdmin && (
                <button 
                  onClick={(e) => removeFeatured(e, product.id)} 
                  className="remove-button"
                >
                  Remove from Featured
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}